<template>
  <f7-page class="page-main">
    <f7-navbar color="black">
      <f7-nav-left>
        <f7-button
          class="burger show-on-md"
          color="blue"
          fill
          large
          round
          panel-toggle="left"
        >
          <f7-icon f7="bars"></f7-icon>
        </f7-button>

        <f7-button
          href="/media-permissions"
          color="blue"
          class="custome-round hide-on-md"
          fill
          large
          round
        >
          {{
            `Audio: ${
              permissions.microphone === 'granted' ? 'On' : 'Off'
            } / Video: ${permissions.camera === 'granted' ? 'On' : 'Off'}`
          }}
        </f7-button>
      </f7-nav-left>
      <f7-nav-right>
        <user-time></user-time>

        <f7-link href="/chat-bot" class="no-margin-right">
          <span class="mr-10">🤖</span>
          Chat Bot
        </f7-link>

        <f7-link
          class="margin-right hide-on-xl"
          href="https://reallang.com/apps/"
          external
          target="_blank"
        >
          <span class="mr-10">🌟</span>
          Our Apps
        </f7-link>

        <f7-link class="logout-link hide-on-lg" @click="logOut">
          <f7-icon class="mr-10" f7="square_arrow_right" size="24"></f7-icon>
          {{ $t(`log_out`) }}
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block class="center">
      RealLang Chat
    </f7-block>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import removeTokenFromLocalStorage from '@/js/helpers/removeTokenFromLocalStorage.js';

import UserTime from '@/components/UserTime.vue';

export default {
  name: 'Main',

  components: {
    UserTime
  },

  computed: {
    ...mapState({
      user: (state) => state.user.info,
      permissions: (state) => state.permissions
    })
  },

  methods: {
    logOut() {
      this.$f7.dialog.confirm(
        this.$t(`page_profile.want_sign_out`),
        this.$t(`log_out`),
        async () => {
          await this.$echo.leave(`user.${this.user.id}`);

          removeTokenFromLocalStorage();
          this.$f7.loginScreen.open('#loginScreen');
          this.$store.commit('user/SET_USER_INFO', {});
        }
      );
    }
  }
};
</script>

<style lang="less">
.page-main {
  --f7-page-bg-color: #f5f6f8;
}
</style>
